// ENUMS #############################################################
export enum OrganizationEntityTooltipIdentifierEnum {
	ADDRESS = 'address',
	CREATED_DATE = 'createdDate',
	DESCRIPTION = 'description',
	BUSINESS_IDENTIFICATION_NUMBER = 'businessIdentificationNumber',
	IDENTIFICATION_NUMBER = 'identificationNumber',
	LAST_MODIFIED_DATE = 'lastModifiedDate',
	NAME = 'name',
	STATUS = 'status',
	TAXABLE_ENTITY = 'taxableEntity',
	TAX_NUMBER = 'taxNumber',
	VAT_ID = 'vatId',
}

// CONSTANTS #########################################################


// TYPES #############################################################


// INTERFACES ########################################################
export interface IOrganizationEntityTooltipItem {
	identifier: OrganizationEntityTooltipIdentifierEnum;
}


// ENTITIES ##########################################################

